import React from 'react';
import PropTypes from 'prop-types';
import styles from '../no-results-found-banner.module.scss';

export const Tip = ({ title, description }) => {
  return (
    <div className={`col__4-12 ${styles['no-results-found-banner__tip']}`}>
      <h2 className={styles['no-results-found-banner__tip-header']}>{title}</h2>
      <div className={styles['no-results-found-banner__tip-desc']}>{description}</div>
    </div>
  );
};

Tip.displayName = 'Tip';
Tip.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
